import { render, staticRenderFns } from "./UnauthorizedBlock.vue?vue&type=template&id=25bfcc07&scoped=true&"
import script from "./UnauthorizedBlock.vue?vue&type=script&lang=js&"
export * from "./UnauthorizedBlock.vue?vue&type=script&lang=js&"
import style0 from "./UnauthorizedBlock.vue?vue&type=style&index=0&id=25bfcc07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bfcc07",
  null
  
)

export default component.exports